import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, RECONNECTING_MESSAGE } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { status, user, reconnecting } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-bg text-ink-secondary text-sm">
        {reconnecting ? RECONNECTING_MESSAGE : "A carregar…"}
      </div>
    );
  }
  if (status === "anon" || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
